import { useState } from 'react';
import { SVButton } from '../core';
import { useCancelTransactionRequests } from '@/hooks/requests/useTransactionRequests';
import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
} from '@mui/material';
import { MESSAGES } from '@/constants/messages';
import showToast from '@/utils/toast';

type TransactionRequestCancelButtonProps = {
  uuid: string;
};

export default function TransactionRequestCancelButton({
  uuid,
}: TransactionRequestCancelButtonProps) {
  const [open, setOpen] = useState(false);
  const { cancelTransactionRquest, isCancelTransactionRequestPending } =
    useCancelTransactionRequests(uuid);

  async function handleConfirm() {
    try {
      await cancelTransactionRquest();
      showToast({
        type: 'success',
        data: {
          content: `Transaction request successfully canceled`,
        },
      });
      setOpen(false);
    } catch {
      showToast({
        type: 'error',
        data: {
          content: MESSAGES.genericError,
        },
      });
    }
  }

  return (
    <>
      <SVButton onClick={() => setOpen(true)} variant="tertiary">
        Cancel
      </SVButton>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={open}
        onClose={() => setOpen(false)}>
        <DialogContent>
          <Typography variant="h6" component="h2">
            Cancel Transaction Request?
          </Typography>
          <Typography sx={{ mt: 2 }}>
            Are you sure you want to cancel this transaction request?
          </Typography>
        </DialogContent>
        <DialogActions>
          <SVButton variant="tertiary" onClick={() => setOpen(false)}>
            Close
          </SVButton>
          <SVButton
            variant="error"
            isLoading={isCancelTransactionRequestPending}
            onClick={handleConfirm}>
            Confirm
          </SVButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
